import script from "./systemMenuXiao.vue?vue&type=script&setup=true&lang=js"
export * from "./systemMenuXiao.vue?vue&type=script&setup=true&lang=js"

import "./systemMenuXiao.vue?vue&type=style&index=0&id=db65e610&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db65e610"]])

export default __exports__